import { useStore } from 'hooks/useStore';

export const useCleanCalculation = () => {
  const { cleanCalculationsStore } = useStore();

  // Format clean time (minutes) for display
  const formatCleanTime = (minutes: number | string | undefined | null): string => {
    if (minutes === undefined || minutes === null) {
      return '-';
    }
    const numericValue = typeof minutes === 'string' ? parseInt(minutes, 10) : minutes;

    if (isNaN(numericValue)) {
      return '-';
    }
    if (numericValue === 0) {
      return 'Error';
    }

    return `${minutes}`;
  };

  return {
    formatCleanTime,
    isLoading: cleanCalculationsStore.isLoading
  };
};

export default useCleanCalculation;
